import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import AlertText from 'fe-design-base/molecules/AlertText';

import { getIssueMessage } from 'features/timesheets/TimesheetsPage/dailyReview/DailyReviewView/TableRow/util';

const Issue = ({ issue }) => (
  <AlertText
    variant={issue.get('variant') || 'error'}
    message={
      getIssueMessage(issue) ? getIssueMessage(issue) : issue.get('content')
    }
  />
);

Issue.propTypes = {
  issue: ImmutablePropTypes.map.isRequired,
};

export default Issue;
